// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fOgT","content":"styles_content__NOT61"};